import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import SelectCst from "@components/InputCst/SelectCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../types";
import SectionHeader from "./SectionHeader";

const ComplexitySection: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
}) => {
  const { t } = useTranslation("wizard-activity");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <SectionHeader
        title={t("sections.complexity.title")}
        description={t("sections.complexity.description") || undefined}
      />
      <SelectCst
        id="activity-complexity"
        label={t("fields.complexity") || ""}
        value={data.complexity ?? ""}
        optionsKey="complexity"
        onChange={(next: any) => setData({ complexity: next || null })}
      />
    </Box>
  );
};

export default ComplexitySection;
